const dashIconPrints = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" viewBox="0 0 20 23">
      <g fill="none" fill-rule="evenodd" transform="translate(-2 -1)">
        <rect width="24" height="24"/>
        <g fill="#FFF" fill-rule="nonzero" transform="translate(2 1)">
          <path d="M20,10 C20,8.346 18.654,7 17,7 L15,7 L15,9 L5,9 L5,7 L3,7 C1.346,7 0,8.346 0,10 L0,19 L3,19 L3,23 L17,23 L17,19 L20,19 L20,10 Z M15,21 L5,21 L5,17 L15,17 L15,21 Z M18,17 L17,17 L17,15 L3,15 L3,17 L2,17 L2,10 C2,9.448 2.449,9 3,9 L3,11 L17,11 L17,9 C17.551,9 18,9.448 18,10 L18,17 Z"/>
          <polygon points="5 2 15 2 15 6 17 6 17 0 3 0 3 6 5 6"/>
          <circle cx="15" cy="13" r="1"/>
        </g>
      </g>
    </svg>
`;

export default dashIconPrints;
